import { SettingsLayout } from "../components/SettingsPage/SettingsLayout";

export function SettingsPage() {
  return <SettingsLayout />;
}
